const textItalic = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11 3.5V2H6.5v1.5h1a.37.37 0 0 1 .37.43l-1.18 7.93a.74.74 0 0 1-.69.64H5V14h4.5v-1.5h-.95a.37.37 0 0 1-.37-.43l1.13-7.93a.74.74 0 0 1 .74-.64z"/></svg>',
};

export { textItalic as default };
